// extracted by mini-css-extract-plugin
export default {"publisheMain":"PublishSeries_publisheMain__pat+I","body":"PublishSeries_body__XnwuB","linkRedirect":"PublishSeries_linkRedirect__mCzyc"};